import { format, parseISO } from 'date-fns';

function lastScanDate(scanSentAt, partnerUploadScanAt) {
  if (!scanSentAt) {
    return partnerUploadScanAt || null;
  }
  if (!partnerUploadScanAt) {
    return scanSentAt;
  }

  const scanSentDay = format(parseISO(scanSentAt), 'yyyy-MM-dd');
  const partnerDay = format(parseISO(partnerUploadScanAt), 'yyyy-MM-dd');

  return scanSentDay >= partnerDay ? scanSentAt : partnerUploadScanAt;
}

export default lastScanDate;
